import gql from "graphql-tag";
const updateGenoLabsMutation = gql(`
mutation updateGenoLabs($params: GenoLabsInput!) {
  updateGenoLabs(params: $params) {
  userid
  feature
  date
  data
  }
}
`)
export default updateGenoLabsMutation;
